import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { useTranslation } from '@common/hooks/translation';

import ClientTransactionClient from '../components/client';
import ClientTransactionAdminConfirm from '../components/adminConfirm';
import { useSelector } from 'react-redux';
import { useDataFetch } from '@common/hooks/dataFetch';
import { getWithdrawalRequests } from '@app/dev/helpers/clientTransaction';
import WithdrawRequestItem from './requestItem';
import MoneyAmount from '@common/components/moneyAmount';
import Config from '@app/dev/config/main';
import { getAuthData } from '@common/helpers/auth';

const WithdrawChooseRequest = ({ client, onBack, onNext }) => {
  const t = useTranslation();
  const [activeRequest, setActiveRequest] = useState(null);

  const isAdminLoggedIn = useSelector((state) => state.terminal.isAdminLoggedIn);

  const [isAdminConfirmed, setIsAdminConfirmed] = useState(isAdminLoggedIn);

  const [requests] = useDataFetch(() => isAdminConfirmed && getWithdrawalRequests(client.Id), [isAdminConfirmed, client]);

  useEffect(() => {
    if (isAdminLoggedIn) setIsAdminConfirmed(true);
  }, [isAdminLoggedIn]);

  const taxAmount = activeRequest?.Amount * client.WithdrawalTaxPercentage / 100
  const currencyConfig = { name: getAuthData()?.currency, rate: 1, rounding: 2 }

  return (
    <div className="ct-form">
      <h3 className="ct-form-title">{t('Withdraw')}</h3>
      {isAdminConfirmed && <p className="ct-form-subtitle">{t('Select withdrawal request then proceed the withdraw')}</p>}

      <ClientTransactionClient data={client} />

      {!!requests?.length && (
        <div className="ct-form-withdraw-requests">
          {requests.map((request) => (
            <WithdrawRequestItem
              key={request.Id}
              data={request}
              isActive={activeRequest?.Id == request.Id}
              onClick={() => setActiveRequest(request)}
            />
          ))}
        </div>
      )}

      {!isAdminConfirmed && <ClientTransactionAdminConfirm />}

      {
        !!client.WithdrawalTaxPercentage && !!activeRequest &&
          <div className='ct-info-container'>
            <div className="ct-info-row">
              <span>{t('Withdrawal tax')}: {client.WithdrawalTaxPercentage}%</span>
              <span>
                <MoneyAmount
                  config={Config}
                  amount={taxAmount}
                  currencyConfig={currencyConfig}
                />
              </span>
            </div>
            <div className="ct-info-row">
              <span>{t('Total withdraw amount')}</span>
              <span>
                <MoneyAmount
                  config={Config}
                  amount={activeRequest.Amount - taxAmount}
                  currencyConfig={currencyConfig}
                />
              </span>
            </div>
          </div>
      }

      <div className="ct-form-buttons">
        <button onClick={onBack}>{t('Back')}</button>
        <button
          className="ct-form-submit-btn"
          disabled={!activeRequest}
          onClick={() => onNext(activeRequest)}
        >{t('Continue')}</button>
      </div>
    </div>
  );
};

WithdrawChooseRequest.propTypes = {
  client: PropTypes.object.isRequired,
  onBack: PropTypes.func,
  onNext: PropTypes.func,
};

export default WithdrawChooseRequest; 